import { render } from "./socialList.vue?vue&type=template&id=3400fce6&scoped=true"
import script from "./socialList.vue?vue&type=script&lang=js"
export * from "./socialList.vue?vue&type=script&lang=js"

import "./socialList.vue?vue&type=style&index=0&id=3400fce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3400fce6"]])

export default __exports__